/* Mikaya — AJAX cart helpers (quick add, buy now, bundles, free-gift chooser).

   Cart state is rendered in up to four places at once: the header bubble, the
   cart drawer, the cart notification, and — on /cart — the full cart page.
   The theme addresses line items by their 1-based INDEX, so any write that
   re-renders only some of those leaves the rest pointing at stale rows: the
   next quantity change then edits the wrong product, or fails outright with
   "There was an error while updating your cart." Every write below therefore
   asks for, and re-renders, whichever of the four are present. */
(function () {
  var MK = (window.MKCart = window.MKCart || {});

  // Cart-page sections are template-scoped, so their ids are read off the DOM.
  function cartPageTargets() {
    var out = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset && el.dataset.id) {
        out.push({ section: el.dataset.id, host: '#' + id + ' .js-contents', pick: ['.js-contents'] });
      }
    });
    return out;
  }

  function targets() {
    var t = [];
    if (document.querySelector('#CartDrawer')) t.push({ section: 'cart-drawer', host: '#CartDrawer', pick: ['#CartDrawer'] });
    if (document.getElementById('cart-notification')) t.push({ section: 'cart-notification', host: '#cart-notification', pick: ['#cart-notification'] });
    if (document.getElementById('cart-icon-bubble')) t.push({ section: 'cart-icon-bubble', host: '#cart-icon-bubble', pick: ['#cart-icon-bubble', '.shopify-section'] });
    return t.concat(cartPageTargets());
  }

  // Section ids for the `sections` param of /cart/*.js.
  MK.sectionIds = function () {
    return targets().map(function (t) { return t.section; });
  };

  // Common body fields. sections_url matters: without it Shopify renders the
  // cart-page sections against the wrong template and returns unusable HTML.
  MK.body = function (extra) {
    var body = { sections: MK.sectionIds().join(','), sections_url: window.location.pathname };
    Object.keys(extra || {}).forEach(function (k) { body[k] = extra[k]; });
    return body;
  };

  MK.post = function (url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  };

  // Replace the innards of every cart surface present, then let listeners know.
  MK.render = function (sections, itemCount) {
    if (sections) {
      var parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
      targets().forEach(function (t) {
        var html = sections[t.section];
        if (!html) return;
        var cur = document.querySelector(t.host);
        if (!cur) return;
        var parsed = parse(html);
        var fresh = null;
        for (var i = 0; i < t.pick.length && !fresh; i++) fresh = parsed.querySelector(t.pick[i]);
        if (fresh) cur.innerHTML = fresh.innerHTML;
      });
    }

    if (typeof itemCount === 'number') {
      ['cart-items', 'cart-drawer', '#main-cart-footer'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) el.classList.toggle('is-empty', itemCount === 0);
      });
    }

    document.dispatchEvent(new CustomEvent('mk:cart:updated'));
  };

  // The cart page's milestone bar + gift chooser live OUTSIDE `.js-contents`, so
  // neither the theme's re-render nor MK.render touches them — the bar would keep
  // showing whatever was true when the page first loaded ("you've unlocked a free
  // wax tablet" on a cart that had since dropped below the threshold). Re-render it
  // from the cart-items section. Returns a promise so callers can sequence after it.
  MK.refreshShipbar = function () {
    var cur = document.querySelector('.mk-cart-page-shipbar');
    var items = document.getElementById('main-cart-items');
    if (!cur || !items || !items.dataset || !items.dataset.id) return Promise.resolve();
    return fetch('/cart?section_id=' + encodeURIComponent(items.dataset.id), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.mk-cart-page-shipbar');
        if (!fresh) return;
        var openPanel = cur.querySelector('.mk-offers__more');
        var wasOpen = openPanel && openPanel.open;
        cur.innerHTML = fresh.innerHTML;
        var newPanel = cur.querySelector('.mk-offers__more');
        if (newPanel && wasOpen) newPanel.open = true;
      })
      .catch(function () {});
  };

  function openDrawerOrNotify(btn) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.classList.remove('is-empty');
      drawer.open(btn);
      return;
    }
    var notif = document.getElementById('cart-notification');
    if (notif && notif.classList) notif.classList.add('active');
  }

  function flash(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1700);
  }

  function addItems(btn, ids) {
    btn.classList.add('is-loading');
    MK.post('/cart/add.js', MK.body({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }))
      .then(function (data) {
        flash(btn);
        MK.render(data && data.sections);
        openDrawerOrNotify(btn);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  // Quick add on a product card.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;
    addItems(btn, [id]);
  });

  // Buy it now: add the form's selected variant + quantity, then go to checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-buynow]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var form = document.getElementById(btn.getAttribute('data-form-id')) || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    // Buy Now skips the form entirely — it never picks up the PDP gift
    // message field, which is only wired to submit with the normal Add to
    // Cart form (it lives outside buy-buttons.liquid via a `form` attribute
    // so that shared Dawn snippet doesn't need editing). Read it directly.
    var item = { id: Number(idInput.value), quantity: qty };
    var gmField = document.querySelector('[data-mk-gm-mode="pdp"] [data-mk-gm-textarea]');
    if (gmField && gmField.value.trim()) {
      item.properties = { 'Gift Message': gmField.value.trim() };
    }
    btn.classList.add('is-loading');
    MK.post('/cart/add.js', { items: [item] })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  // Add a whole set in one click (wax-tablet bundle).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-addset]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var ids = (btn.getAttribute('data-variant-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!ids.length) return;
    addItems(btn, ids);
  });

  // "Add all to cart" — the current product variant + the single-variant paired
  // items (read from the DOM at click time, since pairs load async).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-addall]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var box = btn.closest('.mk-pairs__box') || document;
    var ids = [];
    var selfSel = document.querySelector('form[action*="/cart/add"] [name="id"], product-info [name="id"], variant-selects [name="id"]');
    if (selfSel && selfSel.value) ids.push(selfSel.value);
    box.querySelectorAll('[data-mk-atc][data-variant-id]').forEach(function (b) {
      var v = b.getAttribute('data-variant-id'); if (v) ids.push(v);
    });
    ids = ids.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    if (ids.length < 2) return;
    addItems(btn, ids);
  });
})();

/* Mikaya — free wax-tablet gift at ₹1999.
   Shopify's Buy X Get Y auto-discount only zeroes a tablet that is already in the
   cart; it never adds one. This watches the qualifying subtotal (everything except
   the gift line) and: reveals the chooser when eligible, adds the picked tablet with
   a _gift line-item property, and removes it again if the cart drops below threshold
   so a shopper never keeps a free tablet they no longer qualify for. */
(function () {
  var MK = window.MKCart;
  var GIFT_PROP = '_gift';
  var busy = false;

  // The tablet is only actually free because the Shopify auto-discount
  // "Spend ₹1999 → Free Wax Tablet" zeroes it. The theme cannot read Shopify
  // Discounts from Liquid or JS, so it cannot know in advance whether that
  // discount is still live. If it ever stops applying (paused, deleted, or a
  // product leaving the Wax Tablets collection), the old code happily added the
  // tablet and the shopper was charged ₹349 for something the page called free.
  // Latch on the first time we see a charged gift line: pull it back out of the
  // cart and stop offering the gift for the rest of the session. Charging for a
  // gift is far worse than silently not offering one.
  var giftUnavailable = false;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isGift(item) {
    var p = item.properties || {};
    return String(p[GIFT_PROP]) === 'true';
  }

  // Qualifying subtotal = every line except the gift, using final (post-discount)
  // prices. Independent of whether the discount is currently active, so removing a
  // paid item can never leave a chargeable "gift" behind.
  var lastCart = null;

  function evaluate(cart) {
    lastCart = cart;
    // The chooser is rendered on BOTH the cart drawer and the cart page, so every
    // copy has to be updated — querySelector alone only ever found the drawer's,
    // leaving the cart-page chooser permanently hidden.
    var wraps = document.querySelectorAll('[data-mk-gift]');
    if (!wraps.length) return;
    var threshold = Number(wraps[0].getAttribute('data-mk-gift-threshold')) || 199900;
    var qualifying = 0;
    var giftItem = null;
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) { giftItem = it; return; }
      qualifying += it.final_line_price;
    });
    var eligible = qualifying >= threshold;

    if (giftItem && !eligible) { removeGift(giftItem); return; }

    if (giftUnavailable) {
      Array.prototype.forEach.call(wraps, function (wrap) {
        wrap.hidden = true;
        wrap.removeAttribute('data-has-gift');
      });
      return;
    }

    Array.prototype.forEach.call(wraps, function (wrap) {
      var head = wrap.querySelector('[data-mk-gift-head]');
      if (giftItem) {
        wrap.hidden = false;
        wrap.setAttribute('data-has-gift', '');
        var name = (giftItem.product_title || '').split('|')[0].trim() || 'wax tablet';
        if (head) {
          head.innerHTML = '🎁 <strong>' + esc(name) + '</strong> added free — ' +
            '<button type="button" class="mk-gift__swap" data-mk-gift-remove>choose a different one</button>';
        }
      } else if (eligible) {
        wrap.hidden = false;
        wrap.removeAttribute('data-has-gift');
        if (head) head.innerHTML = '🎁 Choose your <strong>free wax tablet</strong>';
      } else {
        wrap.hidden = true;
        wrap.removeAttribute('data-has-gift');
      }
    });
  }

  // add/remove share one `busy` flag (only one gift line can exist at a
  // time), but a click arriving while it's true used to just silently do
  // nothing — no feedback, no re-enable. A shopper who tapped "Noor" during
  // that window saw no reaction, tapped again, and — if the in-flight
  // request's own re-render had just reordered the chips — could land on
  // whatever product was now sitting under their finger instead. Locking the
  // chips (pointer-events + a visible "updating" state) the instant any
  // request starts makes a swallowed click impossible rather than just less
  // likely.
  function setGiftBusy(isBusy) {
    document.querySelectorAll('[data-mk-gift]').forEach(function (wrap) {
      wrap.classList.toggle('is-updating', isBusy);
      wrap.querySelectorAll('[data-mk-gift-add], [data-mk-gift-remove]').forEach(function (btn) {
        btn.disabled = isBusy;
      });
    });
  }

  function cartTotal() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.total_price; });
  }

  function addGift(variantId) {
    if (busy || !variantId || giftUnavailable) return;
    busy = true;
    setGiftBusy(true);
    var item = { id: Number(variantId), quantity: 1, properties: {} };
    item.properties[GIFT_PROP] = 'true';
    var before = null;
    // Verify against the CART TOTAL, not the gift line's own price. Shopify is
    // free to allocate the discount to a wax tablet the shopper already paid
    // for rather than to the new gift line — we saw it do exactly that — so a
    // priced gift line is not by itself proof the discount failed. What is
    // proof: the total going UP after adding something billed as free.
    cartTotal()
      .then(function (t) { before = t; return MK.post('/cart/add.js', MK.body({ items: [item] })); })
      .then(function (data) {
        busy = false;
        MK.render(data && data.sections);
        return cartTotal();
      })
      .then(function (after) {
        if (before === null || after <= before) return;
        giftUnavailable = true;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var g = (c.items || []).filter(isGift)[0];
            if (g) removeGift(g);
          });
      })
      .catch(function () { busy = false; setGiftBusy(false); });
  }

  function removeGift(item) {
    if (busy || !item) return;
    busy = true;
    setGiftBusy(true);
    MK.post('/cart/change.js', MK.body({ id: item.key, quantity: 0 }))
      .then(function (cart) { busy = false; MK.render(cart && cart.sections, cart && cart.item_count); })
      .catch(function () { busy = false; setGiftBusy(false); });
  }

  // Re-render the cart-page bar FIRST, then evaluate: the fresh markup arrives with
  // Liquid's `hidden` attribute back on the chooser, so evaluate has to run last to
  // reapply the current gift state.
  function refresh() {
    return Promise.resolve(MK.refreshShipbar())
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(evaluate)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-mk-gift-add]');
    if (add) { e.preventDefault(); addGift(add.getAttribute('data-variant-id')); return; }
    var rm = e.target.closest('[data-mk-gift-remove]');
    if (rm) {
      e.preventDefault();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var g = (cart.items || []).find(isGift);
          if (g) removeGift(g);
        })
        .catch(function () {});
    }
  });

  // Re-evaluate after our own writes...
  document.addEventListener('mk:cart:updated', refresh);
  document.addEventListener('mk:cart:refresh', refresh);

  // ...and after the THEME's writes. Quantity steppers and remove buttons publish
  // 'cart-update' through pubsub.js; without this subscription a cart that dropped
  // back under the threshold kept its free tablet, still priced at ₹0.
  if (typeof subscribe === 'function') {
    var evt = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
    subscribe(evt, function () { refresh(); });
  }

  // The theme's own add-to-cart re-renders the cart drawer AFTER publishing
  // cartUpdate, so `evaluate` ran against nodes that were then thrown away and
  // replaced by fresh Liquid markup carrying `hidden` again. Net effect: a
  // shopper who crossed ₹1999 by adding to cart never saw the chooser at all
  // until some later event happened to re-run it. Re-apply the cached state
  // whenever a new chooser node is swapped into the DOM.
  var reapply = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches('[data-mk-gift]') || n.querySelector('[data-mk-gift]')) {
          if (lastCart) evaluate(lastCart); else refresh();
          return;
        }
      }
    }
  });
  reapply.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();

/* Mikaya — per-line "gift message" strip (hamper products only). Debounced
   save to /cart/change.js keyed by the line's unique `key`, never its
   position — this store has already been bitten once by index-addressed
   cart writes editing the wrong row (see the header comment above). The
   write REPLACES a line's entire properties object, so any existing
   properties are read off a data attribute and merged in rather than
   overwritten. */
(function () {
  var MK = window.MKCart;
  var PROP = 'Gift Message';
  var timers = {};
  var lastSaved = {};
  var DEBOUNCE_MS = 700;

  // Per-line save queue. Debounce + the blur-flush can both fire close
  // together (a shopper tabs away right after their last keystroke); running
  // them concurrently raced two /cart/change.js calls against each other.
  var queues = {};

  // Shopify's `item.properties | json` serializes as an array of [key, value]
  // pairs, not a JSON object — the Liquid side now builds the attribute by
  // hand to avoid that, but normalize defensively here too in case a tab is
  // still holding an attribute value rendered before this fix.
  function normalizeProperties(parsed) {
    var out = {};
    if (Array.isArray(parsed)) {
      parsed.forEach(function (pair) {
        if (Array.isArray(pair) && pair.length === 2) out[pair[0]] = pair[1];
      });
    } else if (parsed && typeof parsed === 'object') {
      Object.keys(parsed).forEach(function (k) { out[k] = parsed[k]; });
    }
    return out;
  }

  // Visible, no-click confirmation. NOT an in-place class flash on the
  // pill — Shopify's own shop-js cart-sync module (visible in the network
  // tab as init-shop-cart-sync / shop-cart-sync) independently re-renders
  // the drawer shortly after any /cart/*.js call completes, which wiped an
  // in-place flash before its own timeout ran, with no way to hook into or
  // predict that re-render. A toast appended to <body>, outside every
  // surface's re-rendered subtree, can't be wiped by it.
  var toastTimer;
  function showSavedToast() {
    var toast = document.getElementById('mk-gm-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mk-gm-toast';
      toast.className = 'mk-gm-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.textContent = '✓ Gift message saved';
      document.body.appendChild(toast);
    }
    clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  function doSave(root, value) {
    var key = root.getAttribute('data-mk-gm-key');
    var variantId = root.getAttribute('data-mk-gm-variant-id');
    var status = root.querySelector('[data-mk-gm-status]');
    var existing = {};
    try { existing = normalizeProperties(JSON.parse(root.getAttribute('data-mk-gm-existing') || '{}')); } catch (e) {}
    var properties = {};
    Object.keys(existing).forEach(function (k) { properties[k] = existing[k]; });
    properties[PROP] = value;

    if (status) status.textContent = 'Saving…';
    return MK.post('/cart/change.js', MK.body({ id: key, properties: properties }))
      .then(function (cart) {
        // Shopify derives a line's `key` from variant_id + properties, so
        // changing properties changes the key server-side. Re-sync it from
        // the response every time (regardless of which render path we take
        // below) — otherwise the NEXT save on this line reuses a key that no
        // longer exists and Shopify 400s it with "no valid id or line
        // parameter".
        var fresh = (cart && cart.items || []).filter(function (it) {
          return String(it.variant_id) === String(variantId) && (it.properties || {})[PROP] === value;
        }).pop();
        if (fresh) root.setAttribute('data-mk-gm-key', fresh.key);

        // Re-render everything (see MK.render), but the textarea the shopper
        // is actively typing in would otherwise be torn out from under them
        // mid-keystroke on a slow connection — only re-render if this one
        // isn't focused right now.
        var active = document.activeElement;
        var stillEditing = active && active.hasAttribute('data-mk-gm-textarea') && active.closest('[data-mk-gm]') === root;
        if (!stillEditing) {
          MK.render(cart && cart.sections, cart && cart.item_count);
        } else {
          // Keep the saved-state markers in sync without touching the DOM
          // the shopper is looking at. setAttribute handles its own
          // escaping — hand-encoding quotes here previously stored literal
          // "&quot;" text that failed to JSON.parse on the next save.
          root.setAttribute('data-mk-gm-existing', JSON.stringify(properties));
        }
        // Same confirmation either way — see showSavedToast for why this is
        // a toast and not an in-place flash on the pill.
        showSavedToast();
      })
      .catch(function () {
        if (status) status.textContent = 'Could not save — try again';
      });
  }

  function save(root, value) {
    var variantId = root.getAttribute('data-mk-gm-variant-id');
    var prior = queues[variantId] || Promise.resolve();
    var next = prior
      .then(function () { return doSave(root, value); })
      .then(function () { lastSaved[variantId] = value; })
      .catch(function () {});
    queues[variantId] = next;
    return next;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mk-gm-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-mk-gm]');
    var panel = root.querySelector('[data-mk-gm-panel]');
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
    if (!expanded) {
      var ta = panel.querySelector('[data-mk-gm-textarea]');
      if (ta) ta.focus();
    }
  });

  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-mk-gm-textarea]');
    if (!ta) return;
    var root = ta.closest('[data-mk-gm]');
    var count = root.querySelector('[data-mk-gm-count]');
    if (count) count.textContent = ta.value.length + '/200';

    // PDP mode has no cart line yet — it's a plain form field that submits
    // with Add to Cart / is read directly by Buy Now (see the buynow
    // handler above). Nothing to autosave until it's actually in the cart.
    if (root.getAttribute('data-mk-gm-mode') !== 'cart') return;

    // Keyed by variant id, not data-mk-gm-key — that key changes on every
    // save (Shopify recomputes a line's key from variant_id + properties),
    // so clearing/scheduling by it let a stale timer from before the LAST
    // save survive uncancelled, firing a redundant second /cart/change.js
    // moments later.
    var variantId = root.getAttribute('data-mk-gm-variant-id');
    clearTimeout(timers[variantId]);
    timers[variantId] = setTimeout(function () { save(root, ta.value); }, DEBOUNCE_MS);
  });

  // Flush immediately on blur so a fast tab-away or drawer-close right after
  // typing never loses an unsaved message to the debounce window.
  document.addEventListener(
    'blur',
    function (e) {
      var ta = e.target.closest && e.target.closest('[data-mk-gm-textarea]');
      if (!ta) return;
      var root = ta.closest('[data-mk-gm]');
      if (root.getAttribute('data-mk-gm-mode') !== 'cart') return;
      var variantId = root.getAttribute('data-mk-gm-variant-id');
      clearTimeout(timers[variantId]);
      // If the debounced save already landed with this exact value (the
      // common case — blur usually follows a keystroke by more than
      // DEBOUNCE_MS), skip a second redundant round trip; it only delays the
      // save-confirmation toast for no benefit.
      if (lastSaved[variantId] === ta.value) return;
      save(root, ta.value);
    },
    true
  );
})();
